class AMCDateUtil {
    static getPreviousDateByMonths(baseDate = new Date(), month = 0) {
        let startDate = new Date(baseDate.setHours(0, 0, 0, 0));
        let endDate = new Date(baseDate.setHours(23, 59, 59, 999));

        startDate.setMonth(startDate.getMonth() - month);
        startDate.setDate(startDate.getDate() + 1);

        return { startDate, endDate };
    }

    static getNextDateByMonths(baseDate = new Date(), month = 0) {
        let startDate = new Date(baseDate.setHours(0, 0, 0, 0));
        let endDate = new Date(baseDate.setHours(23, 59, 59, 999));

        endDate.setMonth(endDate.getMonth() + month);

        return { startDate, endDate };
    }
}

export default AMCDateUtil;
